export default "__VITE_ASSET__dcafd52f__"